import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, Switch, TextField } from '@mui/material';
import { Lang, Roles, UserAttrs, apiPost, brandNewUserEmail, brandNewUserPhone, newUser, userEmailValidator, userPhoneValidator, userSlice } from 'cdx-common';
import React from 'react';
import { appStore } from '../../store';




export const CreateUserView = (props: { onClose: () => void; }) => {


    const [user, setUser] = React.useState({ ...newUser });
    const [email, setEmail] = React.useState(brandNewUserEmail);
    const [phone, setPhone] = React.useState(brandNewUserPhone);
    const [isSuperAdmin, setIsSuperAdmin] = React.useState(false);
    const [isForeman, setIsForeman] = React.useState(false);
    const [error, setError] = React.useState('');


    const update = (p: Partial<UserAttrs>) => {
        setUser(q => {
            return { ...q, ...p };
        });
    };

    const onSubmit = async () => {

        let invalid = false;

        if (email.email) {
            console.log('email', email);
            const validatedEmail = await userEmailValidator.validate(email);
            setEmail(validatedEmail);
            invalid = invalid || !!validatedEmail.__errors?.email;
        }

        if (phone.phone) {
            const validatedPhone = await userPhoneValidator.validate(phone);
            setPhone(validatedPhone);
            invalid = invalid || !!validatedPhone.__errors?.phone;
        }
        if (!invalid) {
            const response = await apiPost('userCreate', {
                email: email.email,
                phone: phone.phone,
                name: user.name,
                isForeman,
                isSuperAdmin,
            });
            if (typeof response == 'string') {
                setError(response);
            } else {
                setError('');
                appStore.dispatch(userSlice.actions.addOne(response));
                props.onClose();
                //navigate('/user/' + response.id);
            }
        }
    };

    return <Dialog open={true} onClose={props.onClose}>
        <DialogContent>
            <DialogTitle>Nouvel {Lang('user')}</DialogTitle>
            <Grid container spacing={2}>
                {error !== '' && <Grid item xs={12}><Alert color='error'>{error}</Alert></Grid>}
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label='Prénom et nom'
                        value={user.name}
                        onChange={event => update({ name: event.target.value })} />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        type='email'
                        label='Adresse courriel'
                        error={!!email.__errors?.email}
                        helperText={email.__errors?.email}
                        value={email.email}
                        onChange={event => setEmail(p => { return { ...p, email: event.target.value }; })} />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        type='tel'
                        label='Téléphone mobile (SMS)'
                        error={!!phone.__errors?.phone}
                        helperText={phone.__errors?.phone}
                        value={phone.phone}
                        onChange={event => setPhone(p => { return { ...p, phone: event.target.value }; })} />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel control={<Switch checked={isSuperAdmin} onChange={() => setIsSuperAdmin(!isSuperAdmin)} />} label={Lang('roles.' + Roles.SUPERADMIN)} />
                    <FormControlLabel control={<Switch checked={isForeman} onChange={() => setIsForeman(!isForeman)} />} label={Lang('roles.' + Roles.FOREMAN)} />
                </Grid>
                <DialogActions>
                    <Button color='primary' onClick={onSubmit}>Créer</Button>
                    <Button color='secondary' onClick={props.onClose}>Annuler</Button>
                </DialogActions>
            </Grid>
        </DialogContent>
    </Dialog>;
};
